import { Loading } from '@1trading/react/components/ui/loading';
import type React from 'react';

import BaseLayout from '@/layouts/base';

const LoadingPage = ({ children }: React.PropsWithChildren) => {
  return (
    <BaseLayout className="-md:justify-center">
      <div className="flex flex-col items-center justify-center space-y-4">
        <Loading variant="primary" />
        {children}
      </div>
    </BaseLayout>
  );
};
LoadingPage.displayName = 'LoadingPage';

export default LoadingPage;
